import { render, staticRenderFns } from "./OskoProfileModal.vue?vue&type=template&id=6f6a6db6&"
import script from "./OskoProfileModal.vue?vue&type=script&lang=js&"
export * from "./OskoProfileModal.vue?vue&type=script&lang=js&"
import style0 from "./OskoProfileModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports